import { z } from 'zod';

export const COST_CENTER_KINDS = ['PRODUCTIVE', 'ADMINISTRATIVE', 'COMMERCIAL'] as const;
export const CostCenterKindSchema = z.enum(COST_CENTER_KINDS);

export const UpsertCollaboratorClassificationBodySchema = z.object({
  costCenterKind: CostCenterKindSchema.nullable(),
  payrollPlaceId: z.uuid().nullable(),
});

export type UpsertCollaboratorClassificationBody = z.infer<
  typeof UpsertCollaboratorClassificationBodySchema
>;

export const CollaboratorClassificationResponseSchema = z.object({
  userId: z.uuid(),
  costCenterKind: CostCenterKindSchema.nullable(),
  payrollPlaceId: z.uuid().nullable(),
});

export type CollaboratorClassificationResponse = z.infer<
  typeof CollaboratorClassificationResponseSchema
>;
